import { DialogTitle, DialogContent, Dialog } from "@mui/material";
import { useTranslation } from "react-i18next";
import SitemapGroupDialogBody from "./SitemapGroupDialogBody";
import { isEmpty } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { sitemapSection } from "../../../../../../utils/constants";
import { closeEditModal } from "../../../../../../store/redux/slice/ComponentsControl/sitemapControl";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";

const SitemapGroupDialog = () => {
  const dispatch = useAppDispatch();

  const { open, object } = useAppSelector((state) => {
    return state.ComponentsControl.sitemapControl.sections[sitemapSection.group].modals.edit;
  });

  const handleCloseDialog = () => {
    dispatch(closeEditModal({ section: sitemapSection.group }));
  };

  const { t } = useTranslation();
  const isEditMode = !isEmpty(object.id);

  return (
    <div>
      <Dialog
        PaperProps={{ sx: { position: "fixed", top: "10%", m: 0 } }}
        open={open}
        fullWidth={true}
        maxWidth={"md"}
        onClose={() => handleCloseDialog()}
        aria-labelledby="sitemap-group-dialog-title"
      >
        <DialogTitle id="sitemap-group-dialog-title" style={{ textAlign: "center" }}>
          {!isEditMode && t("t.sitemap.group.create.dialog")}
          {isEditMode && t("t.sitemap.group.edit.dialog")}
        </DialogTitle>
        <DialogContent>
          <SitemapGroupDialogBody editingGroup={object} setOpen={handleCloseDialog} isEditMode={isEditMode} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SitemapGroupDialog;
